/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  ActionIcon,
  Badge,
  Button,
  Center,
  Divider,
  Group,
  Modal,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  Tooltip,
} from '@mantine/core';
import {
  IconBriefcase,
  IconCheck,
  IconCoin,
  IconEdit,
  IconEye,
  IconPackage,
  IconPlus,
  IconRecycle,
  IconRuler2,
  IconScale,
  IconShare,
  IconTarget,
  IconTruck,
  IconX,
} from '@tabler/icons-react';
import { useState } from 'react';
import ProfileCardLink from '../../../../components/core/ProfileCardLink/ProfileCardLink';
import { EntityTypeType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import { Action } from '../../../../models/core/core.type';
import {
  ProposalResiduePlanCodeEnum,
  ProposalResiduePlanDestinationType,
  ProposalResiduePlanEquipmentType,
  ProposalResiduePlanPackagingType,
  ProposalResiduePlanQuotationDestinationType,
  ProposalResiduePlanQuotationEquipmentType,
  ProposalResiduePlanQuotationPackagingType,
  ProposalResiduePlanQuotationTreatmentType,
  ProposalResiduePlanQuotationType,
  ProposalResiduePlanQuotationVehicleType,
  ProposalResiduePlanTreatmentType,
  ProposalResiduePlanType,
  ProposalResiduePlanVehicleType,
} from '../../../../models/core/proposals.type';
import { formatCurrency } from '../../../../utils/formatter.utils';
import { isNullOrEmpty } from '../../../../utils/helper.utils';
import DeleteConfirmPopover from '../../../../components/DeleteConfirmPopover';
import ResidueQuotationDestinationModal from './ResidueQuotationDestinationModal';
import ResidueQuotationEquipmentModal from './ResidueQuotationEquipmentModal';
import ResidueQuotationPackagingModal from './ResidueQuotationPackagingModal';
import ResidueQuotationTreatmentModal from './ResidueQuotationTreatmentModal';
import ResidueQuotationVehicleModal from './ResidueQuotationVehicleModal';

type PageViewPropertyProps = {
  data: ProposalResiduePlanType;
  compra?: boolean | null;
  quotation: ProposalResiduePlanQuotationType | null;
  isEdit?: boolean;
  requireSupplier?: boolean;
  hidePackagingSection?: boolean;
  hideEquipmentSection?: boolean;
  hideVehicleSection?: boolean;
  hideTreatmentSection?: boolean;
  hideDestinationSection?: boolean;
  referenceData?: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  services?: any[];
  zIndex?: number;
  onItemQuotationAction?: (
    quotation: ProposalResiduePlanQuotationType,
    quotationTab: string,
    itemId: string | number
  ) => void;
  onItemDeleteAction?: (
    quotation: ProposalResiduePlanQuotationType,
    quotationTab: string,
    itemId: string | number
  ) => void;
  onItemToleranceAction?: (
    quotation: ProposalResiduePlanQuotationType,
    quotationTab: string,
    itemId: string | number
  ) => void;
  onAddItemQuotationAction?: (quotation: ProposalResiduePlanQuotationType, quotationTab: string) => void;
  onEquipmentQuotationSubmit?: (
    refItem: ProposalResiduePlanEquipmentType,
    item: ProposalResiduePlanQuotationEquipmentType | null,
    action: string
  ) => void;
  onPackagingQuotationSubmit?: (
    refItem: ProposalResiduePlanPackagingType,
    item: ProposalResiduePlanQuotationPackagingType | null,
    action: string
  ) => void;
  onVehicleQuotationSubmit?: (
    refItem: ProposalResiduePlanVehicleType,
    item: ProposalResiduePlanQuotationVehicleType | null,
    action: string
  ) => void;
  onTreatmentQuotationSubmit?: (
    refItem: ProposalResiduePlanTreatmentType,
    item: ProposalResiduePlanQuotationTreatmentType | null,
    action: string
  ) => void;
  onDestinationQuotationSubmit?: (
    refItem: ProposalResiduePlanDestinationType,
    item: ProposalResiduePlanQuotationDestinationType | null,
    action: string
  ) => void;
};

type QuotationCardItem = {
  id: string | number;
  quotationTab: string;
  label: string;
  invalid?: boolean;
  supplierId: number | null;
  supplierCNPJ: string | null;
  supplierFantasyName: string | null;
  supplierCorporateName: string | null;
  supplierCPF: string | null;
  supplierName: string | null;
  quantityLabel: string | null;
  price: number | null;
  receita?: boolean | null;
  cobrarSemUso?: boolean | null;
  tolerances: number;
  gerenciar?: boolean;
  compartilhado?: boolean;
  customerPrice: number | null;
  customerQuantityLabel: string;
};

type QuotationBlockProps = {
  label: string;
  icon: typeof IconPackage;
  items: QuotationCardItem[];
  quotationTab: string;
  hasPendingQuotationItem?: boolean;
  tone?: 'neutral' | 'success' | 'warning' | 'danger';
  onAddAction?: () => void;
  onQuotationClick?: (item: QuotationCardItem) => void;
  onToleranceClick?: (item: QuotationCardItem) => void;
};

export default function ResiduePlanQuotationSummary(props: PageViewPropertyProps) {
  const quotation =
    props.quotation ?? props.data.cotacoes.find((y) => y.primario) ?? props.data.cotacoes[0] ?? null;
  const isMasterPlan =
    (props.data.codigoPlanoTipo || ProposalResiduePlanCodeEnum.Mobilization) ===
    ProposalResiduePlanCodeEnum.Mobilization;
  const showPackagingSection = isMasterPlan && !props.hidePackagingSection;
  const showEquipmentSection = isMasterPlan && !props.hideEquipmentSection;
  const showVehicleSection = !isMasterPlan && !props.hideVehicleSection;
  const showTreatmentSection = !isMasterPlan && !props.hideTreatmentSection;
  const showDestinationSection = !isMasterPlan && !props.hideDestinationSection;
  const [equipmentModalOpened, setEquipmentModalOpened] = useState(false);
  const [selectedEquipmentRefItem, setSelectedEquipmentRefItem] =
    useState<ProposalResiduePlanEquipmentType | null>(null);
  const [selectedEquipmentQuotationItem, setSelectedEquipmentQuotationItem] =
    useState<ProposalResiduePlanQuotationEquipmentType | null>(null);
  const [equipmentModalTab, setEquipmentModalTab] = useState('Cotacao');
  const [packagingModalOpened, setPackagingModalOpened] = useState(false);
  const [selectedPackagingRefItem, setSelectedPackagingRefItem] =
    useState<ProposalResiduePlanPackagingType | null>(null);
  const [selectedPackagingQuotationItem, setSelectedPackagingQuotationItem] =
    useState<ProposalResiduePlanQuotationPackagingType | null>(null);
  const [packagingModalTab, setPackagingModalTab] = useState('Cotacao');
  const [vehicleModalOpened, setVehicleModalOpened] = useState(false);
  const [selectedVehicleRefItem, setSelectedVehicleRefItem] = useState<ProposalResiduePlanVehicleType | null>(
    null
  );
  const [selectedVehicleQuotationItem, setSelectedVehicleQuotationItem] =
    useState<ProposalResiduePlanQuotationVehicleType | null>(null);
  const [vehicleModalTab, setVehicleModalTab] = useState('Cotacao');
  const [treatmentModalOpened, setTreatmentModalOpened] = useState(false);
  const [selectedTreatmentRefItem, setSelectedTreatmentRefItem] =
    useState<ProposalResiduePlanTreatmentType | null>(null);
  const [selectedTreatmentQuotationItem, setSelectedTreatmentQuotationItem] =
    useState<ProposalResiduePlanQuotationTreatmentType | null>(null);
  const [treatmentModalTab, setTreatmentModalTab] = useState('Cotacao');
  const [destinationModalOpened, setDestinationModalOpened] = useState(false);
  const [selectedDestinationRefItem, setSelectedDestinationRefItem] =
    useState<ProposalResiduePlanDestinationType | null>(null);
  const [selectedDestinationQuotationItem, setSelectedDestinationQuotationItem] =
    useState<ProposalResiduePlanQuotationDestinationType | null>(null);
  const [destinationModalTab, setDestinationModalTab] = useState('Cotacao');
  const [selectionModalOpened, setSelectionModalOpened] = useState(false);
  const [selectionModalTitle, setSelectionModalTitle] = useState('');
  const [selectionItems, setSelectionItems] = useState<{ key: string; label: string; onClick: () => void }[]>(
    []
  );

  const matchesByKey = (
    left: string | number | null | undefined,
    right: string | number | null | undefined
  ) => {
    if (
      left === null ||
      left === undefined ||
      right === null ||
      right === undefined ||
      left === '' ||
      right === ''
    ) {
      return false;
    }

    return `${left}` === `${right}`;
  };

  const matchesPlanItem = (
    planItem: {
      id?: string | number | null;
      idTemporaria?: string | number | null;
      relatedId?: string | number | null;
      residueId?: string | number | null;
    },
    quotationItem: {
      id?: string | number | null;
      idTemporaria?: string | number | null;
      relatedId?: string | number | null;
      residueId?: string | number | null;
    }
  ) =>
    matchesByKey(planItem.relatedId, quotationItem.relatedId) ||
    matchesByKey(planItem.id, quotationItem.relatedId) ||
    matchesByKey(planItem.idTemporaria, quotationItem.relatedId) ||
    matchesByKey(planItem.id, quotationItem.id) ||
    matchesByKey(planItem.id, quotationItem.idTemporaria) ||
    matchesByKey(planItem.idTemporaria, quotationItem.id) ||
    matchesByKey(planItem.idTemporaria, quotationItem.idTemporaria) ||
    matchesByKey(planItem.residueId, quotationItem.residueId);

  const isInvalidResidueQuotationLink = (refItem: unknown, idsMatch: boolean) => !refItem || !idsMatch;

  const resolveResidueIdWithFallback = (
    residueId: string | number | null | undefined,
    fallbackResidueId: string | number | null | undefined
  ) => (isNullOrEmpty(residueId) ? fallbackResidueId : residueId);

  const resolveQuotationLabel = (itemLabel: string | null | undefined, refLabel: string | null | undefined) =>
    itemLabel?.trim() || refLabel?.trim() || '-';

  const buildSupplierData = (item: QuotationCardItem) => {
    if (!item.supplierId) {
      return (
        <Text size="xs" c="dimmed">
          Fornecedor indefinido
        </Text>
      );
    }

    if (item.supplierCNPJ) {
      return (
        <ProfileCardLink
          id={item.supplierId.toString()}
          name={item.supplierFantasyName || item.supplierCorporateName || '-'}
          nameSize="xs"
          description={item.supplierFantasyName ? item.supplierCorporateName : item.supplierCNPJ}
          descriptionSize="xs"
          linkPrefix="entities"
          showLink={false}
          showAvatar={false}
        />
      );
    }

    return (
      <ProfileCardLink
        id={item.supplierId.toString()}
        name={item.supplierName || '-'}
        nameSize="sm"
        description={item.supplierCPF}
        descriptionSize="xs"
        linkPrefix="entities"
        showLink={false}
      />
    );
  };

  const openEquipmentQuotationModal = (
    refItem: ProposalResiduePlanEquipmentType,
    item?: ProposalResiduePlanQuotationEquipmentType | null,
    defaultActiveKey = 'Cotacao'
  ) => {
    setSelectedEquipmentRefItem(refItem);
    setSelectedEquipmentQuotationItem(item || null);
    setEquipmentModalTab(defaultActiveKey);
    setEquipmentModalOpened(true);
  };
  const openPackagingQuotationModal = (
    refItem: ProposalResiduePlanPackagingType,
    item?: ProposalResiduePlanQuotationPackagingType | null,
    defaultActiveKey = 'Cotacao'
  ) => {
    setSelectedPackagingRefItem(refItem);
    setSelectedPackagingQuotationItem(item || null);
    setPackagingModalTab(defaultActiveKey);
    setPackagingModalOpened(true);
  };
  const openVehicleQuotationModal = (
    refItem: ProposalResiduePlanVehicleType,
    item?: ProposalResiduePlanQuotationVehicleType | null,
    defaultActiveKey = 'Cotacao'
  ) => {
    setSelectedVehicleRefItem(refItem);
    setSelectedVehicleQuotationItem(item || null);
    setVehicleModalTab(defaultActiveKey);
    setVehicleModalOpened(true);
  };
  const openTreatmentQuotationModal = (
    refItem: ProposalResiduePlanTreatmentType,
    item?: ProposalResiduePlanQuotationTreatmentType | null,
    defaultActiveKey = 'Cotacao'
  ) => {
    setSelectedTreatmentRefItem(refItem);
    setSelectedTreatmentQuotationItem(item || null);
    setTreatmentModalTab(defaultActiveKey);
    setTreatmentModalOpened(true);
  };
  const openDestinationQuotationModal = (
    refItem: ProposalResiduePlanDestinationType,
    item?: ProposalResiduePlanQuotationDestinationType | null,
    defaultActiveKey = 'Cotacao'
  ) => {
    setSelectedDestinationRefItem(refItem);
    setSelectedDestinationQuotationItem(item || null);
    setDestinationModalTab(defaultActiveKey);
    setDestinationModalOpened(true);
  };
  const openSelectionModal = (
    title: string,
    items: { key: string; label: string; onClick: () => void }[]
  ) => {
    setSelectionModalTitle(title);
    setSelectionItems(items);
    setSelectionModalOpened(true);
  };

  const buildCompactBlock = (config: QuotationBlockProps) => (
    <Paper
      p="xs"
      withBorder
      style={{
        backgroundColor:
          config.tone === 'success'
            ? '#f1f8f2'
            : config.tone === 'warning'
            ? '#fff9e8'
            : config.tone === 'danger'
            ? '#fff1f0'
            : undefined,
      }}
    >
      <Stack gap={6}>
        <Group justify="space-between" align="center">
          <Group gap={6}>
            <config.icon size={15} />
            <Text size="sm" fw={500}>
              {config.label}
            </Text>
          </Group>
          {props.isEdit &&
          config.hasPendingQuotationItem &&
          (config.onAddAction || props.onAddItemQuotationAction) ? (
            <Tooltip label="Adicionar cotação" withArrow>
              <ActionIcon
                size="sm"
                color="blue"
                variant="light"
                onClick={() =>
                  config.onAddAction
                    ? config.onAddAction()
                    : props.onAddItemQuotationAction?.(quotation!, config.quotationTab)
                }
              >
                <IconPlus size={15} />
              </ActionIcon>
            </Tooltip>
          ) : (
            <Badge variant="outline" size="sm">
              {config.items.length}
            </Badge>
          )}
        </Group>

        {!config.items.length && (
          <Text size="xs" c="dimmed">
            Nenhum item.
          </Text>
        )}

        {config.items.map((item) => (
          <Paper
            key={`${config.label}_${item.id}`}
            p="xs"
            withBorder
            style={{
              backgroundColor: item.invalid ? '#fdeaea' : undefined,
              borderColor: item.invalid ? '#f08c82' : undefined,
            }}
          >
            <Stack gap={6}>
              <Group justify="space-between" align="flex-start" wrap="nowrap">
                <Group gap={4} className="custom-mantine-badge-group-down">
                  {item.gerenciar ? <IconBriefcase size={14} /> : <></>}
                  {item.compartilhado ? <IconShare size={14} /> : <></>}
                  <Badge variant="outline" size="sm" color={item.invalid ? 'red' : undefined}>
                    {item.label}
                  </Badge>
                </Group>
                <Group gap={4} className="custom-mantine-badge-group-down">
                  <IconScale size={14} />
                  <Badge variant="outline" size="sm">
                    {item.tolerances}
                  </Badge>
                  {item.cobrarSemUso !== undefined && (
                    <Badge variant="outline" size="sm">
                      <Center>
                        {item.cobrarSemUso ? (
                          <IconCheck size={12} color="green" />
                        ) : (
                          <IconX size={12} color="red" />
                        )}
                      </Center>
                    </Badge>
                  )}
                </Group>
              </Group>

              <Divider />

              <Group justify="space-between">
                <Group gap={4}>
                  <IconCoin size={14} />
                  <Text size="xs" fw={500} c={!!item.receita && props.compra ? 'red' : 'green'}>
                    {`${!!item.receita && props.compra ? '-' : '+'}${formatCurrency(item.customerPrice)}`}
                  </Text>
                </Group>
                <Group gap={4}>
                  <IconRuler2 size={14} />
                  <Text size="xs">{item.customerQuantityLabel}</Text>
                </Group>
              </Group>

              <Divider />

              {buildSupplierData(item)}

              <Group justify="space-between" wrap="nowrap">
                <Group gap={4}>
                  <IconCoin size={14} />
                  <Text
                    size="xs"
                    fw={500}
                    c={
                      isNullOrEmpty(item.price)
                        ? 'dimmed'
                        : item.receita
                        ? 'green'
                        : item.cobrarSemUso !== undefined && !item.cobrarSemUso
                        ? 'orange'
                        : 'red'
                    }
                  >
                    {isNullOrEmpty(item.price)
                      ? '-'
                      : `${item.receita ? '+' : '-'}${formatCurrency(item.price!)}`}
                  </Text>
                </Group>
                <Group gap={4}>
                  <IconRuler2 size={14} />
                  <Text size="xs">{item.quantityLabel ?? '-'}</Text>
                </Group>
              </Group>

              <Divider />

              <Group justify="flex-end" gap={6}>
                {(config.onQuotationClick || props.onItemQuotationAction) && (
                  <Tooltip label={props.isEdit ? 'Editar cotação' : 'Ver cotação'} withArrow>
                    <ActionIcon
                      size="sm"
                      variant="light"
                      onClick={() =>
                        config.onQuotationClick
                          ? config.onQuotationClick(item)
                          : props.onItemQuotationAction?.(quotation!, item.quotationTab, item.id)
                      }
                    >
                      {props.isEdit ? <IconEdit size={15} /> : <IconEye size={15} />}
                    </ActionIcon>
                  </Tooltip>
                )}
                {(config.onToleranceClick || props.onItemToleranceAction) && (
                  <Tooltip label={props.isEdit ? 'Editar tolerâncias' : 'Ver tolerâncias'} withArrow>
                    <ActionIcon
                      size="sm"
                      color="grape"
                      variant="light"
                      onClick={() =>
                        config.onToleranceClick
                          ? config.onToleranceClick(item)
                          : props.onItemToleranceAction?.(quotation!, item.quotationTab, item.id)
                      }
                    >
                      <IconScale size={15} />
                    </ActionIcon>
                  </Tooltip>
                )}
                {props.isEdit && props.onItemDeleteAction && (
                  <DeleteConfirmPopover
                    label="Excluir cotação"
                    message="Esta ação removerá a cotação do item do plano."
                    onConfirm={() => props.onItemDeleteAction?.(quotation!, item.quotationTab, item.id)}
                  />
                )}
              </Group>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </Paper>
  );

  const mapPackaging = (item: ProposalResiduePlanQuotationPackagingType): QuotationCardItem => {
    const refItem = props.data.acondicionamentos.find((x) =>
      matchesPlanItem(
        {
          id: x.id,
          idTemporaria: x.idTemporaria,
          relatedId: x.idPropostaResiduoPlanoAcondicionamento,
          residueId: x.idResiduoAcondicionamento,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoAcondicionamento,
          residueId: item.idResiduoAcondicionamento,
        }
      )
    );

    return {
      id:
        item.id ||
        item.idPropostaResiduoPlanoCotacaoAcondicionamento ||
        item.idTemporaria ||
        item.residuoAcondicionamento,
      quotationTab: 'Acondicionamentos',
      label: resolveQuotationLabel(item.residuoAcondicionamento, refItem?.residuoAcondicionamento),
      invalid: isInvalidResidueQuotationLink(
        refItem,
        Number(refItem?.idResiduoAcondicionamento) ===
          Number(
            resolveResidueIdWithFallback(item.idResiduoAcondicionamento, refItem?.idResiduoAcondicionamento)
          )
      ),
      supplierId: item.idFornecedor,
      supplierCNPJ: item.fornecedorCNPJ,
      supplierFantasyName: item.fornecedorNomeFantasia,
      supplierCorporateName: item.fornecedorRazaoSocial,
      supplierCPF: item.fornecedorCPF,
      supplierName: item.fornecedorNome,
      quantityLabel: isNullOrEmpty(item.quantidade)
        ? null
        : `${item.quantidade} ${item.quantidadeUnidadeMedida} / ${item.frequenciaUnidadeMedida}`,
      price: item.preco,
      receita: false,
      customerPrice: item.precificacao?.preco,
      customerQuantityLabel: `${item.precificacao?.quantidade} ${item.precificacao?.quantidadeUnidadeMedida} / ${item.precificacao?.frequenciaUnidadeMedida}`,
      cobrarSemUso: item.cobrarSemUso,
      tolerances: item.tolerancias.length,
      gerenciar: refItem?.gerenciar,
      compartilhado: refItem?.compartilhado,
    };
  };

  const mapEquipment = (item: ProposalResiduePlanQuotationEquipmentType): QuotationCardItem => {
    const refItem = props.data.equipamentos.find((x) =>
      matchesPlanItem(
        {
          id: x.id,
          idTemporaria: x.idTemporaria,
          relatedId: x.idPropostaResiduoPlanoEquipamento,
          residueId: x.idResiduoEquipamento,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoEquipamento,
          residueId: item.idResiduoEquipamento,
        }
      )
    );

    return {
      id:
        item.id ||
        item.idPropostaResiduoPlanoCotacaoEquipamento ||
        item.idTemporaria ||
        item.residuoEquipamento,
      quotationTab: 'Equipamentos',
      label: resolveQuotationLabel(item.residuoEquipamento, refItem?.residuoEquipamento),
      invalid: isInvalidResidueQuotationLink(
        refItem,
        Number(refItem?.idResiduoEquipamento) ===
          Number(resolveResidueIdWithFallback(item.idResiduoEquipamento, refItem?.idResiduoEquipamento))
      ),
      supplierId: item.idFornecedor,
      supplierCNPJ: item.fornecedorCNPJ,
      supplierFantasyName: item.fornecedorNomeFantasia,
      supplierCorporateName: item.fornecedorRazaoSocial,
      supplierCPF: item.fornecedorCPF,
      supplierName: item.fornecedorNome,
      quantityLabel: isNullOrEmpty(item.quantidade)
        ? null
        : `${item.quantidade} ${item.quantidadeUnidadeMedida} / ${item.frequenciaUnidadeMedida}`,
      price: item.preco,
      receita: false,
      customerPrice: item.precificacao?.preco,
      customerQuantityLabel: `${item.precificacao?.quantidade} ${item.precificacao?.quantidadeUnidadeMedida} / ${item.precificacao?.frequenciaUnidadeMedida}`,
      tolerances: item.tolerancias.length,
    };
  };

  const mapVehicle = (item: ProposalResiduePlanQuotationVehicleType): QuotationCardItem => {
    const refItem =
      props.data.veiculo &&
      matchesPlanItem(
        {
          id: props.data.veiculo.id,
          idTemporaria: props.data.veiculo.idTemporaria,
          relatedId: props.data.veiculo.idPropostaResiduoPlanoVeiculo,
          residueId: props.data.veiculo.idResiduoVeiculo,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoVeiculo,
          residueId: item.idResiduoVeiculo,
        }
      )
        ? props.data.veiculo
        : null;

    return {
      id: item.id || item.idPropostaResiduoPlanoCotacaoVeiculo || item.idTemporaria || item.residuoVeiculo,
      quotationTab: 'Veiculos',
      label: resolveQuotationLabel(item.residuoVeiculo, refItem?.residuoVeiculo),
      invalid: isInvalidResidueQuotationLink(
        refItem,
        Number(refItem?.idResiduoVeiculo) ===
          Number(resolveResidueIdWithFallback(item.idResiduoVeiculo, refItem?.idResiduoVeiculo))
      ),
      supplierId: item.idFornecedor,
      supplierCNPJ: item.fornecedorCNPJ,
      supplierFantasyName: item.fornecedorNomeFantasia,
      supplierCorporateName: item.fornecedorRazaoSocial,
      supplierCPF: item.fornecedorCPF,
      supplierName: item.fornecedorNome,
      quantityLabel: isNullOrEmpty(item.quantidade)
        ? null
        : `${item.quantidade} ${item.quantidadeUnidadeMedida} / ${item.frequenciaUnidadeMedida}`,
      price: item.preco,
      receita: false,
      customerPrice: item.precificacao?.preco,
      customerQuantityLabel: `${item.precificacao?.quantidade} ${item.precificacao?.quantidadeUnidadeMedida} / ${item.precificacao?.frequenciaUnidadeMedida}`,
      tolerances: item.tolerancias.length,
    };
  };

  const mapTreatment = (item: ProposalResiduePlanQuotationTreatmentType): QuotationCardItem => {
    const refItem =
      props.data.tratamento &&
      matchesPlanItem(
        {
          id: props.data.tratamento.id,
          idTemporaria: props.data.tratamento.idTemporaria,
          relatedId: props.data.tratamento.idPropostaResiduoPlanoTratamento,
          residueId: props.data.tratamento.idResiduoTratamento,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoTratamento,
          residueId: item.idResiduoTratamento,
        }
      )
        ? props.data.tratamento
        : null;

    return {
      id:
        item.id ||
        item.idPropostaResiduoPlanoCotacaoTratamento ||
        item.idTemporaria ||
        item.residuoTratamento,
      quotationTab: 'Tratamentos',
      label: resolveQuotationLabel(item.residuoTratamento, refItem?.residuoTratamento),
      invalid: isInvalidResidueQuotationLink(
        refItem,
        Number(refItem?.idResiduoTratamento) ===
          Number(resolveResidueIdWithFallback(item.idResiduoTratamento, refItem?.idResiduoTratamento))
      ),
      supplierId: item.idFornecedor,
      supplierCNPJ: item.fornecedorCNPJ,
      supplierFantasyName: item.fornecedorNomeFantasia,
      supplierCorporateName: item.fornecedorRazaoSocial,
      supplierCPF: item.fornecedorCPF,
      supplierName: item.fornecedorNome,
      quantityLabel: isNullOrEmpty(item.quantidade)
        ? null
        : `${item.quantidade} ${item.quantidadeUnidadeMedida}`,
      price: item.preco,
      receita: false,
      customerPrice: item.precificacao?.preco,
      customerQuantityLabel: `${item.precificacao?.quantidade} ${item.precificacao?.quantidadeUnidadeMedida}`,
      tolerances: item.tolerancias.length,
    };
  };

  const mapDestination = (item: ProposalResiduePlanQuotationDestinationType): QuotationCardItem => {
    const refItem =
      props.data.destinoFinal &&
      matchesPlanItem(
        {
          id: props.data.destinoFinal.id,
          idTemporaria: props.data.destinoFinal.idTemporaria,
          relatedId: props.data.destinoFinal.idPropostaResiduoPlanoDestinoFinal,
          residueId: props.data.destinoFinal.idResiduoDestinoFinal,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoDestinoFinal,
          residueId: item.idResiduoDestinoFinal,
        }
      )
        ? props.data.destinoFinal
        : null;

    return {
      id:
        item.id ||
        item.idPropostaResiduoPlanoCotacaoDestinoFinal ||
        item.idTemporaria ||
        item.residuoDestinoFinal,
      quotationTab: 'DestinoFinais',
      label: resolveQuotationLabel(item.residuoDestinoFinal, refItem?.residuoDestinoFinal),
      invalid: isInvalidResidueQuotationLink(
        refItem,
        Number(refItem?.idResiduoDestinoFinal) ===
          Number(resolveResidueIdWithFallback(item.idResiduoDestinoFinal, refItem?.idResiduoDestinoFinal))
      ),
      supplierId: item.idFornecedor,
      supplierCNPJ: item.fornecedorCNPJ,
      supplierFantasyName: item.fornecedorNomeFantasia,
      supplierCorporateName: item.fornecedorRazaoSocial,
      supplierCPF: item.fornecedorCPF,
      supplierName: item.fornecedorNome,
      quantityLabel: isNullOrEmpty(item.quantidade)
        ? null
        : `${item.quantidade} ${item.quantidadeUnidadeMedida}`,
      price: item.preco,
      receita: item.receita,
      customerPrice: item.precificacao?.preco,
      customerQuantityLabel: `${item.precificacao?.quantidade} ${item.precificacao?.quantidadeUnidadeMedida}`,
      tolerances: item.tolerancias.length,
    };
  };

  if (!quotation) {
    return (
      <Paper p="xs" withBorder>
        <Text size="xs" c="dimmed">
          Nenhuma cotação cadastrada para este plano.
        </Text>
      </Paper>
    );
  }

  const hasPackagingPendingQuotation = props.data.acondicionamentos
    .filter((x) => (x.action || Action.Nothing) !== Action.Delete)
    .some(
      (planItem) =>
        !quotation.acondicionamentos.some(
          (quotationItem) =>
            (quotationItem.action || Action.Nothing) !== Action.Delete &&
            matchesPlanItem(
              {
                id: planItem.id,
                idTemporaria: planItem.idTemporaria,
                relatedId: planItem.idPropostaResiduoPlanoAcondicionamento,
                residueId: planItem.idResiduoAcondicionamento,
              },
              {
                id: quotationItem.id,
                idTemporaria: quotationItem.idTemporaria,
                relatedId: quotationItem.idPropostaResiduoPlanoAcondicionamento,
                residueId: quotationItem.idResiduoAcondicionamento,
              }
            )
        )
    );

  const hasEquipmentPendingQuotation = props.data.equipamentos
    .filter((x) => (x.action || Action.Nothing) !== Action.Delete)
    .some(
      (planItem) =>
        !quotation.equipamentos.some(
          (quotationItem) =>
            (quotationItem.action || Action.Nothing) !== Action.Delete &&
            matchesPlanItem(
              {
                id: planItem.id,
                idTemporaria: planItem.idTemporaria,
                relatedId: planItem.idPropostaResiduoPlanoEquipamento,
                residueId: planItem.idResiduoEquipamento,
              },
              {
                id: quotationItem.id,
                idTemporaria: quotationItem.idTemporaria,
                relatedId: quotationItem.idPropostaResiduoPlanoEquipamento,
                residueId: quotationItem.idResiduoEquipamento,
              }
            )
        )
    );

  const hasVehiclePendingQuotation =
    !!props.data.veiculo &&
    (props.data.veiculo.action || Action.Nothing) !== Action.Delete &&
    (!quotation.veiculo || (quotation.veiculo.action || Action.Nothing) === Action.Delete);
  const hasVehicleInvalidQuotation =
    !!props.data.veiculo &&
    !!quotation.veiculo &&
    (props.data.veiculo.action || Action.Nothing) !== Action.Delete &&
    (quotation.veiculo.action || Action.Nothing) !== Action.Delete &&
    !matchesPlanItem(
      {
        id: props.data.veiculo.id,
        idTemporaria: props.data.veiculo.idTemporaria,
        relatedId: props.data.veiculo.idPropostaResiduoPlanoVeiculo,
        residueId: props.data.veiculo.idResiduoVeiculo,
      },
      {
        id: quotation.veiculo.id,
        idTemporaria: quotation.veiculo.idTemporaria,
        relatedId: quotation.veiculo.idPropostaResiduoPlanoVeiculo,
        residueId: quotation.veiculo.idResiduoVeiculo,
      }
    );

  const hasTreatmentPendingQuotation =
    !!props.data.tratamento &&
    (props.data.tratamento.action || Action.Nothing) !== Action.Delete &&
    (!quotation.tratamento || (quotation.tratamento.action || Action.Nothing) === Action.Delete);
  const hasTreatmentInvalidQuotation =
    !!props.data.tratamento &&
    !!quotation.tratamento &&
    (props.data.tratamento.action || Action.Nothing) !== Action.Delete &&
    (quotation.tratamento.action || Action.Nothing) !== Action.Delete &&
    !matchesPlanItem(
      {
        id: props.data.tratamento.id,
        idTemporaria: props.data.tratamento.idTemporaria,
        relatedId: props.data.tratamento.idPropostaResiduoPlanoTratamento,
        residueId: props.data.tratamento.idResiduoTratamento,
      },
      {
        id: quotation.tratamento.id,
        idTemporaria: quotation.tratamento.idTemporaria,
        relatedId: quotation.tratamento.idPropostaResiduoPlanoTratamento,
        residueId: quotation.tratamento.idResiduoTratamento,
      }
    );

  const hasDestinationPendingQuotation =
    !!props.data.destinoFinal &&
    (props.data.destinoFinal.action || Action.Nothing) !== Action.Delete &&
    (!quotation.destinoFinal || (quotation.destinoFinal.action || Action.Nothing) === Action.Delete);
  const hasDestinationInvalidQuotation =
    !!props.data.destinoFinal &&
    !!quotation.destinoFinal &&
    (props.data.destinoFinal.action || Action.Nothing) !== Action.Delete &&
    (quotation.destinoFinal.action || Action.Nothing) !== Action.Delete &&
    !matchesPlanItem(
      {
        id: props.data.destinoFinal.id,
        idTemporaria: props.data.destinoFinal.idTemporaria,
        relatedId: props.data.destinoFinal.idPropostaResiduoPlanoDestinoFinal,
        residueId: props.data.destinoFinal.idResiduoDestinoFinal,
      },
      {
        id: quotation.destinoFinal.id,
        idTemporaria: quotation.destinoFinal.idTemporaria,
        relatedId: quotation.destinoFinal.idPropostaResiduoPlanoDestinoFinal,
        residueId: quotation.destinoFinal.idResiduoDestinoFinal,
      }
    );

  const getBlockTone = (
    planCount: number,
    quotationCount: number,
    hasInvalidQuotationItem = false
  ): QuotationBlockProps['tone'] => {
    if (planCount === 0) {
      return 'neutral';
    }

    if (hasInvalidQuotationItem) {
      return 'danger';
    }

    if (quotationCount === 0) {
      return 'danger';
    }

    if (quotationCount < planCount) {
      return 'warning';
    }

    return 'success';
  };

  const packagingPlanCount = props.data.acondicionamentos.filter(
    (x) => (x.action || Action.Nothing) !== Action.Delete
  ).length;
  const equipmentPlanCount = props.data.equipamentos.filter(
    (x) => (x.action || Action.Nothing) !== Action.Delete
  ).length;
  const vehiclePlanCount =
    props.data.veiculo && (props.data.veiculo.action || Action.Nothing) !== Action.Delete ? 1 : 0;
  const treatmentPlanCount =
    props.data.tratamento && (props.data.tratamento.action || Action.Nothing) !== Action.Delete ? 1 : 0;
  const destinationPlanCount =
    props.data.destinoFinal && (props.data.destinoFinal.action || Action.Nothing) !== Action.Delete ? 1 : 0;

  const packagingQuotationItems = quotation.acondicionamentos.filter(
    (x) => (x.action || Action.Nothing) !== Action.Delete
  );
  const equipmentQuotationItems = quotation.equipamentos.filter(
    (x) => (x.action || Action.Nothing) !== Action.Delete
  );
  const vehicleQuotationItems =
    quotation.veiculo && (quotation.veiculo.action || Action.Nothing) !== Action.Delete
      ? [quotation.veiculo]
      : [];
  const treatmentQuotationItems =
    quotation.tratamento && (quotation.tratamento.action || Action.Nothing) !== Action.Delete
      ? [quotation.tratamento]
      : [];
  const destinationQuotationItems =
    quotation.destinoFinal && (quotation.destinoFinal.action || Action.Nothing) !== Action.Delete
      ? [quotation.destinoFinal]
      : [];
  const packagingCardItems = packagingQuotationItems.map(mapPackaging);
  const equipmentCardItems = equipmentQuotationItems.map(mapEquipment);
  const vehicleCardItems = vehicleQuotationItems.map(mapVehicle);
  const treatmentCardItems = treatmentQuotationItems.map(mapTreatment);
  const destinationCardItems = destinationQuotationItems.map(mapDestination);
  const resolveEquipmentRefItem = (item: ProposalResiduePlanQuotationEquipmentType) =>
    props.data.equipamentos.find((entry) =>
      matchesPlanItem(
        {
          id: entry.id,
          idTemporaria: entry.idTemporaria,
          relatedId: entry.idPropostaResiduoPlanoEquipamento,
          residueId: entry.idResiduoEquipamento,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoEquipamento,
          residueId: item.idResiduoEquipamento,
        }
      )
    ) || null;
  const resolvePackagingRefItem = (item: ProposalResiduePlanQuotationPackagingType) =>
    props.data.acondicionamentos.find((entry) =>
      matchesPlanItem(
        {
          id: entry.id,
          idTemporaria: entry.idTemporaria,
          relatedId: entry.idPropostaResiduoPlanoAcondicionamento,
          residueId: entry.idResiduoAcondicionamento,
        },
        {
          id: item.id,
          idTemporaria: item.idTemporaria,
          relatedId: item.idPropostaResiduoPlanoAcondicionamento,
          residueId: item.idResiduoAcondicionamento,
        }
      )
    ) || null;
  const resolveVehicleRefItem = (item: ProposalResiduePlanQuotationVehicleType) =>
    props.data.veiculo &&
    matchesPlanItem(
      {
        id: props.data.veiculo.id,
        idTemporaria: props.data.veiculo.idTemporaria,
        relatedId: props.data.veiculo.idPropostaResiduoPlanoVeiculo,
        residueId: props.data.veiculo.idResiduoVeiculo,
      },
      {
        id: item.id,
        idTemporaria: item.idTemporaria,
        relatedId: item.idPropostaResiduoPlanoVeiculo,
        residueId: item.idResiduoVeiculo,
      }
    )
      ? props.data.veiculo
      : null;
  const resolveTreatmentRefItem = (item: ProposalResiduePlanQuotationTreatmentType) =>
    props.data.tratamento &&
    matchesPlanItem(
      {
        id: props.data.tratamento.id,
        idTemporaria: props.data.tratamento.idTemporaria,
        relatedId: props.data.tratamento.idPropostaResiduoPlanoTratamento,
        residueId: props.data.tratamento.idResiduoTratamento,
      },
      {
        id: item.id,
        idTemporaria: item.idTemporaria,
        relatedId: item.idPropostaResiduoPlanoTratamento,
        residueId: item.idResiduoTratamento,
      }
    )
      ? props.data.tratamento
      : null;
  const resolveDestinationRefItem = (item: ProposalResiduePlanQuotationDestinationType) =>
    props.data.destinoFinal &&
    matchesPlanItem(
      {
        id: props.data.destinoFinal.id,
        idTemporaria: props.data.destinoFinal.idTemporaria,
        relatedId: props.data.destinoFinal.idPropostaResiduoPlanoDestinoFinal,
        residueId: props.data.destinoFinal.idResiduoDestinoFinal,
      },
      {
        id: item.id,
        idTemporaria: item.idTemporaria,
        relatedId: item.idPropostaResiduoPlanoDestinoFinal,
        residueId: item.idResiduoDestinoFinal,
      }
    )
      ? props.data.destinoFinal
      : null;
  const getMissingEquipmentItems = () =>
    props.data.equipamentos.filter(
      (planItem) =>
        (planItem.action || Action.Nothing) !== Action.Delete &&
        !equipmentQuotationItems.some((quotationItem) =>
          matchesPlanItem(
            {
              id: planItem.id,
              idTemporaria: planItem.idTemporaria,
              relatedId: planItem.idPropostaResiduoPlanoEquipamento,
              residueId: planItem.idResiduoEquipamento,
            },
            {
              id: quotationItem.id,
              idTemporaria: quotationItem.idTemporaria,
              relatedId: quotationItem.idPropostaResiduoPlanoEquipamento,
              residueId: quotationItem.idResiduoEquipamento,
            }
          )
        )
    );
  const getMissingPackagingItems = () =>
    props.data.acondicionamentos.filter(
      (planItem) =>
        (planItem.action || Action.Nothing) !== Action.Delete &&
        !packagingQuotationItems.some((quotationItem) =>
          matchesPlanItem(
            {
              id: planItem.id,
              idTemporaria: planItem.idTemporaria,
              relatedId: planItem.idPropostaResiduoPlanoAcondicionamento,
              residueId: planItem.idResiduoAcondicionamento,
            },
            {
              id: quotationItem.id,
              idTemporaria: quotationItem.idTemporaria,
              relatedId: quotationItem.idPropostaResiduoPlanoAcondicionamento,
              residueId: quotationItem.idResiduoAcondicionamento,
            }
          )
        )
    );

  const blocks = [
    showPackagingSection
      ? buildCompactBlock({
          label: 'Acondicionamentos',
          icon: IconPackage,
          quotationTab: 'Acondicionamentos',
          hasPendingQuotationItem: hasPackagingPendingQuotation,
          tone: getBlockTone(
            packagingPlanCount,
            packagingQuotationItems.length,
            packagingCardItems.some((x) => x.invalid)
          ),
          items: packagingCardItems,
          onAddAction:
            props.referenceData && props.onPackagingQuotationSubmit
              ? () => {
                  const missingItems = getMissingPackagingItems();
                  if (missingItems.length === 1) {
                    openPackagingQuotationModal(missingItems[0]);
                  } else if (missingItems.length > 1) {
                    openSelectionModal(
                      'Adicionar cotação de acondicionamento',
                      missingItems.map((item) => ({
                        key: `${item.id || item.idPropostaResiduoPlanoAcondicionamento || item.idTemporaria}`,
                        label: item.residuoAcondicionamento,
                        onClick: () => openPackagingQuotationModal(item),
                      }))
                    );
                  }
                }
              : undefined,
          onQuotationClick: props.referenceData
            ? (cardItem) => {
                const quotationItem = packagingQuotationItems.find(
                  (entry) =>
                    `${
                      entry.id ||
                      entry.idPropostaResiduoPlanoCotacaoAcondicionamento ||
                      entry.idTemporaria ||
                      entry.idResiduoAcondicionamento
                    }` === `${cardItem.id}`
                );
                const refItem = quotationItem ? resolvePackagingRefItem(quotationItem) : null;
                if (quotationItem && refItem) {
                  openPackagingQuotationModal(refItem, quotationItem);
                }
              }
            : undefined,
          onToleranceClick: props.referenceData
            ? (cardItem) => {
                const quotationItem = packagingQuotationItems.find(
                  (entry) =>
                    `${
                      entry.id ||
                      entry.idPropostaResiduoPlanoCotacaoAcondicionamento ||
                      entry.idTemporaria ||
                      entry.idResiduoAcondicionamento
                    }` === `${cardItem.id}`
                );
                const refItem = quotationItem ? resolvePackagingRefItem(quotationItem) : null;
                if (quotationItem && refItem) {
                  openPackagingQuotationModal(refItem, quotationItem, 'Tolerancias');
                }
              }
            : undefined,
        })
      : null,
    showEquipmentSection
      ? buildCompactBlock({
          label: 'Equipamentos',
          icon: IconPackage,
          quotationTab: 'Equipamentos',
          hasPendingQuotationItem: hasEquipmentPendingQuotation,
          tone: getBlockTone(
            equipmentPlanCount,
            equipmentQuotationItems.length,
            equipmentCardItems.some((x) => x.invalid)
          ),
          items: equipmentCardItems,
          onAddAction:
            props.referenceData && props.onEquipmentQuotationSubmit
              ? () => {
                  const missingItems = getMissingEquipmentItems();
                  if (missingItems.length === 1) {
                    openEquipmentQuotationModal(missingItems[0]);
                  } else if (missingItems.length > 1) {
                    openSelectionModal(
                      'Adicionar cotação de equipamento',
                      missingItems.map((item) => ({
                        key: `${item.id || item.idPropostaResiduoPlanoEquipamento || item.idTemporaria}`,
                        label: item.residuoEquipamento,
                        onClick: () => openEquipmentQuotationModal(item),
                      }))
                    );
                  }
                }
              : undefined,
          onQuotationClick: props.referenceData
            ? (cardItem) => {
                const quotationItem = equipmentQuotationItems.find(
                  (entry) =>
                    `${
                      entry.id ||
                      entry.idPropostaResiduoPlanoCotacaoEquipamento ||
                      entry.idTemporaria ||
                      entry.idResiduoEquipamento
                    }` === `${cardItem.id}`
                );
                const refItem = quotationItem ? resolveEquipmentRefItem(quotationItem) : null;
                if (quotationItem && refItem) {
                  openEquipmentQuotationModal(refItem, quotationItem);
                }
              }
            : undefined,
          onToleranceClick: props.referenceData
            ? (cardItem) => {
                const quotationItem = equipmentQuotationItems.find(
                  (entry) =>
                    `${
                      entry.id ||
                      entry.idPropostaResiduoPlanoCotacaoEquipamento ||
                      entry.idTemporaria ||
                      entry.idResiduoEquipamento
                    }` === `${cardItem.id}`
                );
                const refItem = quotationItem ? resolveEquipmentRefItem(quotationItem) : null;
                if (quotationItem && refItem) {
                  openEquipmentQuotationModal(refItem, quotationItem, 'Tolerancias');
                }
              }
            : undefined,
        })
      : null,
    showVehicleSection
      ? buildCompactBlock({
          label: 'Veículo',
          icon: IconTruck,
          quotationTab: 'Veiculos',
          hasPendingQuotationItem: hasVehiclePendingQuotation,
          tone: getBlockTone(
            vehiclePlanCount,
            vehicleQuotationItems.length,
            hasVehicleInvalidQuotation || vehicleCardItems.some((x) => x.invalid)
          ),
          items: vehicleCardItems,
          onAddAction:
            props.referenceData && props.onVehicleQuotationSubmit && props.data.veiculo
              ? () => openVehicleQuotationModal(props.data.veiculo!)
              : undefined,
          onQuotationClick:
            props.referenceData && quotation.veiculo
              ? () => {
                  const refItem = resolveVehicleRefItem(quotation.veiculo!);
                  if (refItem) {
                    openVehicleQuotationModal(refItem, quotation.veiculo!);
                  }
                }
              : undefined,
          onToleranceClick:
            props.referenceData && quotation.veiculo
              ? () => {
                  const refItem = resolveVehicleRefItem(quotation.veiculo!);
                  if (refItem) {
                    openVehicleQuotationModal(refItem, quotation.veiculo!, 'Tolerancias');
                  }
                }
              : undefined,
        })
      : null,
    showTreatmentSection
      ? buildCompactBlock({
          label: 'Tratamento',
          icon: IconRecycle,
          quotationTab: 'Tratamentos',
          hasPendingQuotationItem: hasTreatmentPendingQuotation,
          tone: getBlockTone(
            treatmentPlanCount,
            treatmentQuotationItems.length,
            hasTreatmentInvalidQuotation || treatmentCardItems.some((x) => x.invalid)
          ),
          items: treatmentCardItems,
          onAddAction:
            props.referenceData && props.onTreatmentQuotationSubmit && props.data.tratamento
              ? () => openTreatmentQuotationModal(props.data.tratamento!)
              : undefined,
          onQuotationClick:
            props.referenceData && quotation.tratamento
              ? () => {
                  const refItem = resolveTreatmentRefItem(quotation.tratamento!);
                  if (refItem) {
                    openTreatmentQuotationModal(refItem, quotation.tratamento!);
                  }
                }
              : undefined,
          onToleranceClick:
            props.referenceData && quotation.tratamento
              ? () => {
                  const refItem = resolveTreatmentRefItem(quotation.tratamento!);
                  if (refItem) {
                    openTreatmentQuotationModal(refItem, quotation.tratamento!, 'Tolerancias');
                  }
                }
              : undefined,
        })
      : null,
    showDestinationSection
      ? buildCompactBlock({
          label: 'Destino final',
          icon: IconTarget,
          quotationTab: 'DestinoFinais',
          hasPendingQuotationItem: hasDestinationPendingQuotation,
          tone: getBlockTone(
            destinationPlanCount,
            destinationQuotationItems.length,
            hasDestinationInvalidQuotation || destinationCardItems.some((x) => x.invalid)
          ),
          items: destinationCardItems,
          onAddAction:
            props.referenceData && props.onDestinationQuotationSubmit && props.data.destinoFinal
              ? () => openDestinationQuotationModal(props.data.destinoFinal!)
              : undefined,
          onQuotationClick:
            props.referenceData && quotation.destinoFinal
              ? () => {
                  const refItem = resolveDestinationRefItem(quotation.destinoFinal!);
                  if (refItem) {
                    openDestinationQuotationModal(refItem, quotation.destinoFinal!);
                  }
                }
              : undefined,
          onToleranceClick:
            props.referenceData && quotation.destinoFinal
              ? () => {
                  const refItem = resolveDestinationRefItem(quotation.destinoFinal!);
                  if (refItem) {
                    openDestinationQuotationModal(refItem, quotation.destinoFinal!, 'Tolerancias');
                  }
                }
              : undefined,
        })
      : null,
  ].filter(Boolean);
  return (
    <>
      <SimpleGrid cols={Math.max(blocks.length, 1)} spacing="xs">
        {blocks}
      </SimpleGrid>
      <Modal
        opened={selectionModalOpened}
        onClose={() => {
          setSelectionModalOpened(false);
          setSelectionModalTitle('');
          setSelectionItems([]);
        }}
        title={selectionModalTitle}
        size="md"
        centered
        zIndex={(props.zIndex || 1000) + 20}
      >
        <Stack gap="xs">
          {selectionItems.map((item) => (
            <Button
              key={item.key}
              variant="light"
              justify="flex-start"
              onClick={() => {
                setSelectionModalOpened(false);
                setSelectionModalTitle('');
                setSelectionItems([]);
                item.onClick();
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>
      </Modal>
      {props.referenceData && props.services && selectedPackagingRefItem && (
        <ResidueQuotationPackagingModal
          opened={packagingModalOpened}
          onClose={() => {
            setPackagingModalOpened(false);
            setSelectedPackagingRefItem(null);
            setSelectedPackagingQuotationItem(null);
            setPackagingModalTab('Cotacao');
          }}
          modoEdicao={!!props.isEdit}
          referenceData={props.referenceData}
          services={props.services as any}
          origItem={selectedPackagingQuotationItem}
          item={selectedPackagingQuotationItem}
          refItem={selectedPackagingRefItem}
          idPropostaResiduoPlanoCotacao={quotation.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={packagingModalTab}
          zIndex={props.zIndex || 1000}
          requireSupplier={props.requireSupplier}
          callback={(item, refItem, action, confirmed) => {
            if (!confirmed || !refItem || !props.onPackagingQuotationSubmit) return;
            props.onPackagingQuotationSubmit(refItem, item, action);
          }}
        />
      )}
      {props.referenceData && quotation && selectedEquipmentRefItem && (
        <ResidueQuotationEquipmentModal
          opened={equipmentModalOpened}
          onClose={() => {
            setEquipmentModalOpened(false);
            setSelectedEquipmentRefItem(null);
            setSelectedEquipmentQuotationItem(null);
            setEquipmentModalTab('Cotacao');
          }}
          modoEdicao={!!props.isEdit}
          referenceData={props.referenceData}
          origItem={selectedEquipmentQuotationItem}
          item={selectedEquipmentQuotationItem}
          refItem={selectedEquipmentRefItem}
          idPropostaResiduoPlanoCotacao={quotation.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={equipmentModalTab}
          zIndex={props.zIndex || 1000}
          requireSupplier={props.requireSupplier}
          callback={(item, refItem, action, confirmed) => {
            if (!confirmed || !refItem || !props.onEquipmentQuotationSubmit) {
              return;
            }
            props.onEquipmentQuotationSubmit(refItem, item, action);
          }}
        />
      )}
      {props.referenceData && selectedVehicleRefItem && (
        <ResidueQuotationVehicleModal
          opened={vehicleModalOpened}
          onClose={() => {
            setVehicleModalOpened(false);
            setSelectedVehicleRefItem(null);
            setSelectedVehicleQuotationItem(null);
            setVehicleModalTab('Cotacao');
          }}
          modoEdicao={!!props.isEdit}
          referenceData={props.referenceData}
          origItem={selectedVehicleQuotationItem}
          item={selectedVehicleQuotationItem}
          refItem={selectedVehicleRefItem}
          idPropostaResiduoPlanoCotacao={quotation.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={vehicleModalTab}
          zIndex={props.zIndex || 1000}
          requireSupplier={props.requireSupplier}
          callback={(item, refItem, action, confirmed) => {
            if (!confirmed || !refItem || !props.onVehicleQuotationSubmit) return;
            props.onVehicleQuotationSubmit(refItem, item, action);
          }}
        />
      )}
      {props.referenceData && selectedTreatmentRefItem && (
        <ResidueQuotationTreatmentModal
          opened={treatmentModalOpened}
          onClose={() => {
            setTreatmentModalOpened(false);
            setSelectedTreatmentRefItem(null);
            setSelectedTreatmentQuotationItem(null);
            setTreatmentModalTab('Cotacao');
          }}
          modoEdicao={!!props.isEdit}
          referenceData={props.referenceData}
          origItem={selectedTreatmentQuotationItem}
          item={selectedTreatmentQuotationItem}
          refItem={selectedTreatmentRefItem}
          idPropostaResiduoPlanoCotacao={quotation.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={treatmentModalTab}
          zIndex={props.zIndex || 1000}
          requireSupplier={props.requireSupplier}
          callback={(item, refItem, action, confirmed) => {
            if (!confirmed || !refItem || !props.onTreatmentQuotationSubmit) return;
            props.onTreatmentQuotationSubmit(refItem, item, action);
          }}
        />
      )}
      {props.referenceData && selectedDestinationRefItem && (
        <ResidueQuotationDestinationModal
          opened={destinationModalOpened}
          onClose={() => {
            setDestinationModalOpened(false);
            setSelectedDestinationRefItem(null);
            setSelectedDestinationQuotationItem(null);
            setDestinationModalTab('Cotacao');
          }}
          modoEdicao={!!props.isEdit}
          referenceData={props.referenceData}
          origItem={selectedDestinationQuotationItem}
          item={selectedDestinationQuotationItem}
          refItem={selectedDestinationRefItem}
          idPropostaResiduoPlanoCotacao={quotation.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={destinationModalTab}
          zIndex={props.zIndex || 1000}
          requireSupplier={props.requireSupplier}
          callback={(item, refItem, action, confirmed) => {
            if (!confirmed || !refItem || !props.onDestinationQuotationSubmit) return;
            props.onDestinationQuotationSubmit(refItem, item, action);
          }}
        />
      )}
    </>
  );
}
